import React from 'react';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Paper, Table, TableBody, TablePagination } from "@mui/material";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import Button from '@mui/material/Button';
import FusePageCarded from '@fuse/core/FusePageCarded/FusePageCarded';
import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { DomainContext } from 'src/app/@core/@contexts/domain.context';
import { ModuleContext, initialModuleData, moduleDataContext } from 'src/app/@core/@contexts/module.context';
import { TextInput } from 'src/app/@core/forms/controls/textInput';
import { NoWrapControl } from 'src/app/@core/forms/controls/noWrapControl';
import { isUoN } from 'src/app/@core/common';
import { TBodyCell } from 'src/app/@core/forms/dataTable/dataTable.control';
import { FabricApi } from '../../services/api/fabric.api';

type AdminFabricUploadPageProps = {
  title?: string;
};

const AdminFabricUploadPage: React.FC<AdminFabricUploadPageProps> = () => {

  const dispatch = useDispatch();
  const frmModel = useForm({ mode: 'onChange', defaultValues: {} });
  initialModuleData.loadFormModel(frmModel);

  const [store, setStore] = useState(initialModuleData);

  const { } = useContext(DomainContext);
  const isMobile = useThemeMediaQuery((theme: any) => theme.breakpoints.down('lg'));

  const [fileName, setFileName] = useState('');
  const [file, setFile] = useState(null);
  const hiddenFileInput = useRef<HTMLInputElement>(null);

  type UploadFabric = {

    newPhoto: File;
    currentPhoto: string;
    replace: boolean;
    status: string;

  };


  const [selectedFiles, setSelectedFiles] = useState<UploadFabric[]>([]);

  /**
   * 
   */
  const loadData = () => {
  }

  /**
   * 
   */
  const contextObj = useMemo(() => {

    moduleDataContext.bootstrap(store, setStore);
    moduleDataContext.loadModelDataFunc = loadData;

    return moduleDataContext

  }, [store]);

  /**
   * 
   */
  useEffect(() => {
    loadData();
    return () => { };
  }, [])

  /**
   * 
   * @param {*} e 
   */
  const onFileChange = async (e: any) => {

    let api: any = new FabricApi(DomainContext);
    const fabrics: UploadFabric[] = [];

    const len = e.target.files.length;
    for (let i = 0; i < len; i++) {

      const file = e.target.files[i];
      // const currentPhoto = await api.getFabric(photo.name);
      // console.log(currentPhoto);

      const fabric: UploadFabric = {
        newPhoto: file,
        currentPhoto: 'https://orderentry2.hamiltonshirts.com/images/FabricSwatches/' + file.name,
        replace: true,
        status: 'Completed'
      };
      fabrics.push(fabric);

    }
    setSelectedFiles(fabrics);

    // console.log(e.target.files.length);

    // const file = event.target.files[0];
    // setFileName(file.name)
    // setFile(file);
  };

  /**
   * 
   * @returns 
   */
  const onSubmit = async () => {

    console.log(selectedFiles);

  }

  /**
   * 
   * @returns 
   */
  const onRollback = async () => {


  }

  /**
   * 
   */
  const onSelectFile = () => {

    if (hiddenFileInput.current) hiddenFileInput.current.click();

  };

  /**
   * 
   * @param x 
   */
  const onReplaceChange = (x: UploadFabric) => {
    const fabrics = [...selectedFiles];
    for (let i = 0; i < fabrics.length; i++) {
      if (fabrics[i].newPhoto.name !== x.newPhoto.name) continue;
      fabrics[i].replace = !x.replace;
      break;
    }
    setSelectedFiles(fabrics);
  }

  /**
   * 
   * @param {*} props 
   * @returns 
   */
  const Header = () => {

    return (
      <div style={{ width: "100%" }}>
        <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0 flex-1 w-full items-center justify-between container">
          <Typography className="text-24 md:text-32 font-extrabold tracking-tight">
            Upload Fabrics
          </Typography>
        </div>
        {
          <div style={{ marginBottom: 10 }}>
            <hr />
            <div className="flex flex-row container" style={{ marginTop: 10, justifyContent: 'end' }}>
              <input type="file" multiple onChange={onFileChange} accept=".jpg" ref={hiddenFileInput} style={{ display: "none" }} />
              <Button variant="contained" color="secondary" onClick={onSelectFile}>
                Select File
              </Button>
              &nbsp;
              <Button variant="contained" color="secondary" onClick={onSubmit}>
                Upload
              </Button>
            </div>
          </div>
        }
      </div>
    )
  }

  const columns: any = [
    { id: "fabricID", align: "center", disablePadding: false, label: "Fabric ID", sort: true, width: 200 },
    { id: "newImage", align: "center", disablePadding: false, label: "New Image", sort: true, width: 200 },
    { id: "currentImage", align: "center", disablePadding: false, label: "Current Image", sort: true, width: 200 },
    { id: "replaceImage", align: "center", disablePadding: false, label: "Replace", sort: true, width: 100 },
    { id: "status", align: "center", disablePadding: false, label: "Status", sort: true },
  ];

  /**
   * 
   * @param props 
   * @returns 
   */
  const THeadCell = (props: any) => {

    const { column, sortOrder, onSort } = props;

    return <TableCell
      width={column.width}
      style={{ backgroundColor: "#e1e1e1" }}
      className="p-4 md:p-5"
      align="center"
      padding={column.disablePadding ? "none" : "normal"}

    >
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          {column.sort && (
            <Tooltip title="Sort" placement={column.align === "right" ? "bottom-end" : "bottom-start"} enterDelay={300}>
              <TableSortLabel className="font-semibold">
                {column.label}
              </TableSortLabel>
            </Tooltip>
          )}
        </div>
        {
          column.filter ? column.filter : null
        }
      </div>
    </TableCell>

  }

  /**
   * 
   * @param props 
   * @returns 
   */
  const THead = (props: any) => {

    const { columns, sortOrder, onSort } = props;

    return <TableHead>
      <TableRow className="h-48 sm:h-64">
        {
          columns.map((x: any) => <THeadCell key={x.id} column={x} sortOrder={sortOrder} onSort={onSort} />)
        }
      </TableRow>
    </TableHead>

  }

  /**
   * 
   * @param props 
   * @returns 
   */
  const TBodyCell = (props: any) => {

    const { align, value } = props;

    return <TableCell className="p-4 md:p-5 tbody-cell" component="td" scope="row" align={align} style={{ verticalAlign: 'top' }}>
      {value}
    </TableCell>
  }

  /**
   * 
   * @param {*} props 
   * @returns 
   */
  const Content = () => {

    return <div style={{ padding: 20 }}>
      <Table stickyHeader className="min-w-xl" size="small" aria-labelledby="tableTitle">
        <THead columns={columns} />
        <TableBody>
          {
            selectedFiles.map((x: UploadFabric) => <TableRow key={x.newPhoto.name} className="h-48 sm:h-64">
              <TableCell className="p-4 md:p-5 tbody-cell" component="td" scope="row" align='center' style={{ verticalAlign: 'top' }}>
                {x.newPhoto.name}
              </TableCell>
              <TableCell className="p-4 md:p-5 tbody-cell" component="td" scope="row" align='center' style={{ verticalAlign: 'top' }}>
                <div style={{ display: 'flex', justifyContent: 'center', flex: 1 }}>
                  <img alt="preview image" src={URL.createObjectURL(x.newPhoto)} />
                </div>
              </TableCell>
              <TableCell className="p-4 md:p-5 tbody-cell" component="td" scope="row" align='left' style={{ verticalAlign: 'top' }}>

                <div style={{ display: 'flex', justifyContent: 'center', flex: 1 }}>
                  <img alt="preview image" src={x.currentPhoto} />
                </div>
              </TableCell>
              <TableCell className="p-4 md:p-5 tbody-cell" component="td" scope="row" align='center' style={{ verticalAlign: 'top' }}>
                <input type="checkbox"
                  onChange={() => onReplaceChange(x)}
                  checked={x.replace}
                  style={{ zoom: 1.5, margin: 5 }} />
              </TableCell>
              <TableCell className="p-4 md:p-5 tbody-cell" component="td" scope="row" align='center' style={{ verticalAlign: 'top' }}>
                {
                  x.status
                }
              </TableCell>
            </TableRow>)
          }
        </TableBody>
      </Table>

    </div>
  }

  /**
   * 
   */
  return <ModuleContext.Provider value={contextObj}>
    <FusePageCarded
      header={<Header />}
      content={<Content />}
      scroll={isMobile ? 'normal' : 'content'
      }
    />
  </ModuleContext.Provider>

};

export default AdminFabricUploadPage;
